import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/facilityservice/hospitals');

export const hospitalApiPaths = {
  list: withRoot(''),
  hospitalById: withRoot('/:hospitalId'),
  hospitalContacts: withRoot('/contacts'),
  hospitalContactsByHospitalId: withRoot('/:hospitalId/contacts'),
  hospitalContactById: withRoot('/contacts/:contactId'),
} as const;

export const getHospitalApiUrl = {
  list: () => hospitalApiPaths.list,
  hospitalById: (hospitalId: string) => replacePathParams(hospitalApiPaths.hospitalById, { hospitalId }),
  hospitalContacts: () => hospitalApiPaths.hospitalContacts,
  hospitalContactsByHospitalId: (hospitalId: string) =>
    replacePathParams(hospitalApiPaths.hospitalContactsByHospitalId, { hospitalId }),
  hospitalContactById: (contactId: string) => replacePathParams(hospitalApiPaths.hospitalContactById, { contactId }),
};
